import ApolloClient from 'apollo-client';
import gql from 'graphql-tag';
import { infringementRulesQuery, infringementRulesSchema } from 'src/app/resolvers/schema';

export const fetchInfringementRulesData = (
  client: ApolloClient<object>,
  filterString?: string,
  abortControllerSignal?: AbortSignal
) => {
  return new Promise((resolve, reject) => {
    const queryParams = filterString ? filterString : `filter: {}`;
    const GET_RULES = gql`
      query {
        ${infringementRulesQuery}(${queryParams}) ${infringementRulesSchema} 
      }
    `;
    client
      .query({ query: GET_RULES, context: { fetchOptions: { signal: abortControllerSignal } } })
      .then(response => {
        const {
          data: { infringementRules: data },
        } = response;
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
